
<div class="row m-1">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-2">
                <div class="form-group row">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                        <label style="white-space: nowrap;font-weight: 700;">{{'AttachmentName'| translate}}</label>
                        <span *ngIf="FilName.invalid" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;">
                            <div *ngIf="FilName.errors?.required">*</div>
                        </span>
                    </div>
                    <input #FilName="ngModel" [(ngModel)]="fileName" required id="fileName" placeholder="{{'FileName'| translate}}" class="form-control" name="fileName" type="text">
                </div>
                <!-- <div class="form-group row mt-3">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                        <label style="white-space: nowrap; font-weight: 700;">{{'AttachmentType' | translate}}</label>
                        <span *ngIf="AttachType.invalid" class="alert" style=" color: red; white-space: nowrap; line-height: 0; padding: 0; margin-top: 8px;">
                                <div *ngIf="AttachType.errors?.required">*</div>
                        </span>
                    </div>
                    <ng-select #AttachType="ngModel" required [ngModelOptions]="{standalone: true}" placeholder="{{'AttachmentType' | translate}}" [items]="attachTypesArr" [(ngModel)]="attachTypeId" bindLabel="text" bindValue="id" class="form-control-select" name="attachTypes" style="padding: 0 !important;"></ng-select>
                </div> -->
                <!-- <div class="form-group row mt-3" *ngIf="attachTypeId==100">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px">
                        <label>{{ "otherTypeInfo" | translate }}</label>
                    </div>
                    <input [(ngModel)]="otherTypeInfo" type="text" class="form-control" />
                </div> -->
                <!-- <div class="form-group row mt-3">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px">
                        <label>{{ "incommingOrgName" | translate }}</label>
                      
                    </div>
                    <input  [(ngModel)]="incommingOrgName" type="text" class="form-control" />
                </div> -->
                <!-- <div class="form-group row mt-3">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px">
                        <label>{{ "descriptionAtt" | translate }}</label>
                       
                    </div>
                    <input [(ngModel)]="description" type="text" class="form-control" />
                </div> -->
                
                <div class="form-group row mt-3">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                        <label style="white-space: nowrap; font-weight: 700;">{{'Scanner'| translate}}</label>
                    </div>
                    <select id="source" class="select-control"></select>
                </div>
                <div class="form-group row mt-3">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                        <label style="white-space: nowrap;font-weight: 700;">{{'Resolution'| translate}}</label>
                    </div>
                    <select size="1" id="Resolution"  class="select-control">
                        <option value="100">100dpi</option>
                        <option selected value="150">150dpi</option>
                        <option value="200">200dpi</option>
                    </select>
                </div>
                <div class="form-group row mt-3">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                        <label style="white-space: nowrap;font-weight: 700;">{{'PixelType'| translate}}</label>
                    </div>
                    <select size="1" id="ddlColor"  class="select-control">
                        <option selected value="RGB">{{"Colored"|translate}}</option>
                        <option value="Gray">{{"Gray"|translate}}</option>
                        <option value="BW">{{"B/W"|translate}}</option>
                    </select>
                </div>
                <div class="form-group row mt-3">
                    <div style="display: flex; flex-wrap: nowrap; height: 30px;">
                        <label style="white-space: nowrap;font-weight: 700;">{{'ScannerSettings'| translate}}</label>
                    </div>
                    <div>
                        <label for="ADF" class="" style="padding:0 !important; line-height: 3;">
                            <input id="ADF" checked="checked" type="checkbox"> {{"AutoFeeder"|translate}}
                        </label>
                    </div>
                </div>
                
            </div>
     
            <div class="col-lg-10" >
                <div class="row justify-content-center mb-2">
                    <div class="col-lg-12" style=" display:flex; justify-content:center;">
                        <nav aria-label="Page navigation example float-end">
                            <ul class="pagination">
                                <li class="page-item">
                                    <a class="page-link btn btn-dark m-2" data-toggle="tooltip" title="Disabled tooltip" style="color:#fff !important;" (click)="previous()" href="javascript:void(0)" aria-label="Previous">
                                        <span aria-hidden="true">&laquo;</span>
                                        <span class="sr-only">{{'Previous'|translate}}</span>
                                    </a>
                                </li>
                                <li class="page-item">
                                    <a class="page-link btn btn-dark m-2" ngbPopover="{{'NextPage' | translate}}" (click)="next()" href="javascript:void(0)" aria-label="Next" style="color:#fff !important;">
                                        <span aria-hidden="true">&raquo;</span>
                                        <span class="sr-only">{{'Next' | translate}}</span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <a class="btn btn-primary m-2" onclick="AcquireImage();" ngbPopover="{{'Scan' | translate}}">
                            <app-feather-icons [icon]="'camera'" style="position:relative; top:4px;"></app-feather-icons>
                        </a>
                        <a class="btn btn-primary m-2" onclick="cropImage();" ngbPopover="{{'Cropping' | translate}}">
                            <app-feather-icons [icon]="'crop'" style="position:relative; top:4px;"></app-feather-icons>
                        </a>
                        <button [disabled]="FilName.invalid " class="btn btn-primary m-2" (click)="saveFileAsPdf();" ngbPopover="{{'Save' | translate}}">
                            <app-feather-icons [icon]="'save'" style="position:relative; top:4px;"></app-feather-icons>
                        </button>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="scannereditor">
                            <div id="dwtcontrolContainerLargeViewer" style="display: none;"></div>
                            <div id="dwtcontrolContainer" style="width: 500px;margin: auto;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>